<template>
  <div class="evidencia-mini">
    <div
      v-if="esPdf"
      class="evidencia-pdf d-flex flex-column align-center justify-center"
      :style="{ aspectRatio: String(aspectRatio) }"
    >
      <v-icon color="error" size="42">mdi-file-pdf-box</v-icon>
      <span class="text-caption grey--text text-center px-1 evidencia-pdf__nombre">{{ nombreVisible }}</span>
    </div>
    <video
      v-else-if="esVideo"
      :src="src"
      style="width: 100%; height: 100%;"
      class="d-flex"
    ></video>
    <v-img v-else :src="src" contain :aspect-ratio="aspectRatio"></v-img>
  </div>
</template>

<script>
import { clasificarArchivoEvidencia } from '@/utils/ticketEvidencias'

export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    nombre: {
      type: String,
      default: '',
    },
    video: {
      type: Boolean,
      default: false,
    },
    pdf: {
      type: Boolean,
      default: false,
    },
    aspectRatio: {
      type: [Number, String],
      default: 2,
    },
  },

  computed: {
    tipoPorNombre() {
      return clasificarArchivoEvidencia(this.nombre)
    },

    esPdf() {
      if (this.pdf) return true
      if (this.tipoPorNombre.pdf) return true
      return String(this.src || '').indexOf('application/pdf') !== -1
    },

    esVideo() {
      if (this.esPdf) return false
      if (this.video) return true
      return this.tipoPorNombre.video
    },

    nombreVisible() {
      const partes = String(this.nombre || 'PDF').split('/')
      return partes[partes.length - 1] || 'PDF'
    },
  },
}
</script>

<style scoped>
.evidencia-pdf {
  width: 100%;
  min-height: 88px;
  background: #fafafa;
}

.evidencia-pdf__nombre {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
